export default __webpack_public_path__ + "static/media/Icon-AI-Scanner-Logo.f095b019.svg";